<template>
  <div id="app" class="main">
    <router-view></router-view>
  </div>
</template>

<script>
import { ref } from 'vue'
// import LandingPage from './components/LandingPage'
// import HeaderView from './components/HeaderView'

export default {
  name: 'LayoutDefault',

  components: {
    // LandingPage,
    // HeaderView
  },
  data() {
    return {
      layout: `div`,
    }
  },

  setup () {
    return {
      leftDrawerOpen: ref(false)
    }
  }
}
</script>

<style lang="scss">
.main {
  background-image: url('./assets/bg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  /* Full height */
  height: 100%;
}

</style>
